import Tab from "@mui/material/Tab"
import Tabs from "@mui/material/Tabs"
import { useState } from "react"

import Column from "../../../common/components/Column"
import AdminPageHeader from "../components/AdminPageHeader"
import MeetingQuestionsSection from "./MeetingQuestionsSection"
import MeetingRemindersSection from "./MeetingRemindersSection"
import MeetingTimeZonesSection from "./MeetingTimeZonesSection"

export const CONFIGURATION_SECTIONS = [
  {
    id: "questions",
    label: "Form questions",
    Component: MeetingQuestionsSection,
  },
  {
    id: "reminders",
    label: "Reminder emails",
    Component: MeetingRemindersSection,
  },
  { id: "time-zones", label: "Time zones", Component: MeetingTimeZonesSection },
]

// Everything admins can set for booking, in one place.
export default function MeetingConfigurationPage() {
  const [sectionId, setSectionId] = useState(CONFIGURATION_SECTIONS[0].id)
  const { Component } = CONFIGURATION_SECTIONS.find(
    (section) => section.id === sectionId
  )

  return (
    <Column gap={2}>
      <AdminPageHeader
        title="Booking configuration"
        subtitle="Set up how meetings are booked: the form questions, reminder emails and the time zones offered."
      />
      <Tabs
        value={sectionId}
        onChange={(_, value) => setSectionId(value)}
        aria-label="Booking configuration sections"
      >
        {CONFIGURATION_SECTIONS.map((section) => (
          <Tab key={section.id} value={section.id} label={section.label} />
        ))}
      </Tabs>
      <Component />
    </Column>
  )
}
